import React, { FC, forwardRef, ReactNode } from 'react';
import Dropzone, { DropzoneRef, DropzoneOptions, DropzoneInputProps } from 'react-dropzone-14.2.3';
import classnames from 'classnames';

// @ts-ignore
import { Delete, Fileup } from '../../../icons';

// @ts-ignore
import styles from './FileInput.scss';

export type FileInputProps = DropzoneOptions & {
  isError?: boolean;
  className?: string;
  placeholder?: string;
};

export const FileInput = forwardRef<DropzoneRef, FileInputProps>(
  ({ isError = false, className, placeholder, ...props }, ref) => {
    const classNames = isError ? [styles.dropzone, styles.invalid] : [styles.dropzone];

    return (
      <Dropzone ref={ref} {...props}>
        {({ getRootProps, getInputProps }) => (
          <div className={classnames(classNames)} {...getRootProps()}>
            <Input {...getInputProps()} />
            <span className={styles.placeholder}>{placeholder}</span>
            <i className={styles.iconContainer}>
              <Fileup />
            </i>
          </div>
        )}
      </Dropzone>
    );
  },
);

export const Input = forwardRef<HTMLInputElement, DropzoneInputProps>(({ className, ...props }, ref) => {
  return <input ref={ref} type="file" className={classnames(className, styles.input)} {...props} />;
});

type FileWithUrl = {
  name: string;
  url?: string;
};

type FileItemProps = JSX.IntrinsicElements['div'] & {
  file: FileWithUrl;
  onRemove?: () => void;
};

export const File: FC<FileItemProps> = ({ file, onRemove, className, ...props }) => {
  return (
    <div className={classnames(className, styles.file)} {...props}>
      {file.url ? (
        <a href={file.url} download className={styles.downloadLink} target="_blank" rel="noopener noreferrer">
          {file.name}
        </a>
      ) : (
        file.name
      )}
      <i className={styles.iconContainer}>
        <Delete size={20} onClick={() => onRemove?.()} />
      </i>
    </div>
  );
};

type FileContainerProps = JSX.IntrinsicElements['div'] & {
  children: ReactNode;
};

export const Container: FC<FileContainerProps> = ({ children, className, ...props }) => (
  <div className={classnames(className, styles.container)} {...props}>
    {children}
  </div>
);
